import React, { Component, Fragment } from 'react';
import { createRoot } from 'react-dom/client';
import { isEmpty } from 'lodash-es';
import cx from 'classnames';

import axios from '../../../configs/axios';
import SearchTypeahead from '../../../components/SearchTypeahead';
import NoDataState from './NoDataState';
import Header from './Header';
import AppsList from './AppsList';
import LoadingOverlay from '../../../components/LoadingOverlay';

const rootNode = document.getElementById('sdk-search-root');
const defaultResults = JSON.parse(rootNode.dataset.defaultResults);
const searchAllowed = rootNode.dataset.searchAllowed === 'true';

class SdkSearch extends Component {
  state = {
    results: defaultResults.apps,
    selectedItem: defaultResults.sdk,
    hubspot_contact_present: true,
    forbidden: !searchAllowed,
    appSearch: true,
    pending: false,
  };
  handleChange = ([selectedItem]) => {
    if (!selectedItem) return;
    this.setState(
      {
        selectedItem,
        pending: true,
      },
      () => {
        axios
          .get('/sdk_apps/apps', {
            params: {
              sdk_id: selectedItem.ref_no,
              store: selectedItem.store,
            },
          })
          .then((response) => {
            const { data } = response;
            this.setState({
              results: data.apps,
              hubspot_contact_present: data.hubspot_contact_present,
              forbidden: false,
              appSearch: true,
              pending: false,
            });
          })
          .catch(() => {
            this.setState({
              forbidden: true,
            });
          });
      }
    );
  };
  handleSearch = (results, query, forbidden) => {
    if (this.state.forbidden) {
      return;
    }
    const { searchResults } = results;
    this.setState({
      results: searchResults,
      forbidden,
      appSearch: false,
    });
  };
  filterSearchResults = (result) => {
    if (result.apps) {
      this.setState({
        hubspot_contact_present: result.hubspot_contact_present,
      });
      return result.apps;
    }
    return result;
  };
  render() {
    const { results, appSearch, hubspot_contact_present, selectedItem, forbidden, pending } =
      this.state;
    return (
      <Fragment>
        <LoadingOverlay loading={pending && !forbidden} />
        <div className="flex-no-shrink d-flex flex-wrap flex-row align-items-center justify-content-between sdk-search-holder">
          <div className={cx('sdk-search-input', { 'hidden-dropdown': !pending && forbidden })}>
            <SearchTypeahead
              searchAsset="sdks"
              placeholder="Search for any SDK"
              defaultSearchQuery="/sdk_apps"
              clearButton
              itemSelected={this.handleItemSelected}
              decorateItems={this.filterSearchResults}
              autoFocus={false}
              disabled={forbidden}
              onChange={this.handleChange}
              onSearchCallback={this.handleSearch}
            />
          </div>
        </div>
        <div className="sdk-search-output">
          {forbidden && (
            <p className="text-rose text-center mt-xs">
              Whoops!
              <br />
              It looks like you&apos;ve tried me too much today.
            </p>
          )}
          {appSearch && !isEmpty(results) && !forbidden && (
            <Fragment>
              <Header selectedItem={selectedItem} />
              <AppsList hubspotContactPresent={hubspot_contact_present} apps={results} />
            </Fragment>
          )}
          {appSearch && isEmpty(results) && !forbidden && <NoDataState />}
        </div>
      </Fragment>
    );
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const root = createRoot(rootNode);
  root.render(<SdkSearch />);
});
